document.addEventListener('DOMContentLoaded', function() {
  console.log('⚙️ slider-video.js loaded');

  function resetVideos(){
    document.querySelectorAll('.slider-for .inner-video video')
      .forEach(function(vid){
        vid.pause();
        vid.currentTime = 0;
      });
  }

  // initial
  resetVideos();

  if (window.jQuery && jQuery.fn.slick) {
    jQuery('.slider-for')
      .on('beforeChange', resetVideos)
      .on('afterChange', function(event, slick, currentSlide){
        console.log('🔄 afterChange → slide', currentSlide);
        var slideEl = slick.$slides.eq(currentSlide)[0];
        var vid = slideEl.querySelector('.inner-video video');
        if (vid) {
          console.log('▶️ afterChange playing video');
          vid.currentTime = 0;
          vid.play();
        }
      });
  }

  document.body.addEventListener('click', function(e) {
    var wrapper = e.target.closest('.inner-video');
    if (!wrapper) return;
    var vid = wrapper.querySelector('video');
    if (!vid) return;
    console.log('▶️ click handler playing video');
    vid.currentTime = 0;
    vid.play();
  });

  // ** NEW ** show controls only on hover
  document.querySelectorAll('.slider-for .inner-video').forEach(function(wrapper){
    var vid = wrapper.querySelector('video');
    if (!vid) return;
    vid.controls = false;              // hide by default
    wrapper.addEventListener('mouseenter', function(){
      vid.controls = true;             // show on hover
    });
    wrapper.addEventListener('mouseleave', function(){
      vid.controls = false;            // hide when you leave
    });
  });
});
